export default "/images/vendor/flag-icons/flags/1x1/ht.svg?bb196f2996c1fa63bd46d478054d019f";